export const CARD_VARIANTS = {
  ACTIVE: "active",
  SELECTED: "selected",
  PAST: "past",
} as const;

export const TEXT_TRUNCATE_LENGTH = 120;
